import { loadJs } from 'bits/load'

let beaconInitialized = ''

declare global {
  interface Window { Beacon: any }
}

window.Beacon = (method, options, data): void => {
  window.Beacon.readyQueue.push({ method, options, data })
}

window.Beacon.readyQueue = []

const widgets = {
  chat: '669b3e9b-71cd-48fe-a6b3-f463d1da787f',
}

const scriptUrl = 'https://beacon-v2.helpscout.net'

function initialize (identity, widgetType: string): void {
  window.Beacon('identify', identity)
  window.Beacon('init', widgets[widgetType])
  beaconInitialized = widgets[widgetType]
}

function open (identity, widgetType: string): void {
  if (beaconInitialized !== widgets[widgetType]) {
    initialize(identity, widgetType)
  }
  window.Beacon('open')
}

function showWidget (identity, widgetType): void {
  loadJs(scriptUrl).then((): void => { open(identity, widgetType) })
}

export { showWidget }
